import Service from './Service';

const ServicesList = ({t}) => {
  const services = Object.values(t("pages.services.options", { returnObjects: true })).map(service => ({
    title: service.title,
    description: service.description,
    logo: service.logo
  }));

  return (
    <div className="generic-list">
      {services.map((service, index) => (
        <Service
          key={index}
          logo={service.logo}
          title={service.title}
          description={service.description}
        />
      ))}
    </div>
  );
};

export default ServicesList;